import { render, staticRenderFns } from "./certificateDataOther.vue?vue&type=template&id=39104ff2&"
import script from "./certificateDataOther.vue?vue&type=script&lang=js&"
export * from "./certificateDataOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports